
export const TAB_KEYS = {
    corousel: 'corousel',
    logo: 'logo',
    aboutUs: 'about-us',
    product: 'product',
    service: 'service',
    workExperience: 'work-experience',
    contactUs: 'contact-us',
    apprenticeship: 'PART_TIME',
    vacancy: 'FULL_TIME',
    whyWorkForUs: 'why-work'
}

export const vacancyKeys = ['PART_TIME', 'FULL_TIME']

export const contactUSkeys = {
    sales: 'SALES',
    hr: 'HUMAN_RESOURCE',
    eow: 'EXPERIENCES_OF_WORK'
}

export const contactEnumsArr = ['SALES', 'HUMAN_RESOURCE', 'EXPERIENCES_OF_WORK']

export const dateFormat = "DD/MM/YYYY";

export const inputFieldCharLimit = 100